export default {
  'accountInfo': 'Account Information',
  'personalInfo': 'Personal Information',
  'bankInfo': 'Bank Information',
  'trading_account_info': 'Trading Account Information',
  'addCard': 'Add a Hong Kong Bank Card',
  'bankName': 'Bank Name',
  'bankNum': 'Bank Account Number',
  'englishName': 'Name of the Account Holder/English',
  'chineseName': 'Name of the Account Holder/Chinese',
  'currency': 'Bank Currency',
  'uploadTitle': 'Upload a bank statement (must include bank name, bank account number and your full name )',
  'uploadTips': 'Bank account verification document can be:</br>1. The front of the ATM card with your name and bank account number printed on it;</br>2. Bank account opening letter printed with the date of issue (within 3 months);</br>3. Copy of bank monthly statement/electronic monthly statement with the date of issue (within 3 months). </br>',
  'uploadNotice': 'To protect the security of your acount, customer service will contact you if the verification documents do not meet the requirements.',
  'records': 'Latest Record',
  'toRecords': 'Add Record',
  'error': {
    'bankNamePlaceholder': 'Please select a bank name',
    'bankAccountPlaceholder': 'Please enter the correct bank account number',
    'englishNamePlaceholder': 'Please enter the name of the account holder/English',
    'chineseNamePlaceholder': 'Please enter the name of the account holder/Chinese',
    'currencyPlaceholder': 'Please select a bank currency',
    'otherCurrencyPlaceholder': 'Please upload the bank account proof document',
    'failed': 'Failed to add. Please try again',
    '30014': 'User information is incorrect. Please exit and resubmit.',
    '30015': 'Bank card information is missing. Please resubmit it',
    '30016': 'The bank card number already exists',
    '30017': 'There are unprocessed orders'
  },
  'currencyOpt': {
    'USD': 'USD',
    'HKD': 'HKD',
    'CNY': 'CNY'
  },
  'noRecords': 'No Bank Card Record',
  'name': 'Name',
  'phone': 'Telephone',
  'email': 'E-mail',
  'address': 'Address',
  'STOCK': 'Securities',
  'FUTURES': 'Futures',
  'FOREX': 'Foreign Exchange',
  'IB': 'EddidPro',
  'MF': 'FX Pro',
  'PM': 'Spot Gold',
  'account': 'Account',
  'balance': 'Balance',
  'netCashBalance': 'Net Cash Balance',
  'preBalance': 'Previous Day Balance',
  'loadingData': 'Loading Data...',
  'balanceErr': '--',
  'todayBalance': 'End-of-day balance',
  'stockOptionsCash': 'Hong Kong Stock Option Account (Cash)',
  'securitiesCash': 'Hong Kong and Global Securities Accounts (Cash)',
  'securitiesMargin': 'Hong Kong and Global Securities Accounts (Margin)',
  'securitiesDayTradeMargin': 'Hong Kong Securities Day Trade Account (Margin)',
  'futuresMargin': 'Hong Kong and Global Futures Account (Margin)',
  'futuresDayTradeMargin': 'Hong Kong Futures Day Trade Account (Margin)',
  'interactiveBrokerIntegratedMargin': 'InteractiveBroker Comprehensive Account (Margin)',
  'OPEN': 'Activated',
  'STOP': 'Suspended',
  'CLOSE': 'Closed',
  'withdrawalLimit': 'In order to comply with regulatory requirements, if customers wish to use other newly bound bank accounts for any deposits or withdrawals, the newly bound bank accounts must have a deposit record of not less than HKD 10,000 or equivalent currency; otherwise, Eddid Securities and Futures may not be able to process your deposit and withdrawal requests.',
  'forbidWithdrawal': 'This linked bank account has not successfully deposited an amount of no less than HKD 10,000 or its equivalent in other currencies into Eddid Securities and Futures, and therefore cannot be used for withdrawals.',
  'accountDormant': 'Your trading account {accountNumber} (the "Account") has not engaged in any activity (including trading, deposits, withdrawals, transfers in of stocks, transfers out of stocks, updating account information, logging into the mobile application, etc.) for the past 3 years. To protect the interests of customers, the account is now regarded as "inactive," and the withdrawal and transfer of stocks functions will be restricted.'
}
